export const PUBLIC_ANALYTICS_PLACEMENTS = {
  public_cta_clicked: ["header_signup", "hero_primary", "coach_proof"],
  public_nav_clicked: [
    "header_product",
    "header_progress",
    "header_coach",
    "header_pricing",
    "header_login",
    "hero_product_proof",
  ],
  public_menu_opened: ["mobile_header"],
  pricing_selected: ["free", "premium_monthly"],
} as const;

export type PublicAnalyticsEvent = keyof typeof PUBLIC_ANALYTICS_PLACEMENTS;

export type PublicAnalyticsPlacement<EventType extends PublicAnalyticsEvent> =
  (typeof PUBLIC_ANALYTICS_PLACEMENTS)[EventType][number];

export type PublicAnalyticsEventPlacement = {
  [EventType in PublicAnalyticsEvent]: [
    eventType: EventType,
    placement: PublicAnalyticsPlacement<EventType>,
  ];
}[PublicAnalyticsEvent];

export type PublicAnalyticsPayload = {
  [EventType in PublicAnalyticsEvent]: {
    event_type: EventType;
    metadata: { placement: PublicAnalyticsPlacement<EventType> };
    route: string;
    user_id: null;
  };
}[PublicAnalyticsEvent];

export function isPublicAnalyticsPlacement(
  eventType: string,
  placement: string,
): boolean {
  if (!Object.prototype.hasOwnProperty.call(PUBLIC_ANALYTICS_PLACEMENTS, eventType)) {
    return false;
  }

  return (
    PUBLIC_ANALYTICS_PLACEMENTS[eventType as PublicAnalyticsEvent] as readonly string[]
  ).includes(placement);
}

export function buildPublicAnalyticsPayload(
  eventType: string,
  placement: string,
  pathname: string,
): PublicAnalyticsPayload | null {
  if (!isPublicAnalyticsPlacement(eventType, placement)) return null;

  return {
    event_type: eventType,
    metadata: { placement },
    route: pathname,
    user_id: null,
  } as PublicAnalyticsPayload;
}
